export { default } from './Desc';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/ReferralProgram/ReferralMyStat/Desc/index.js